import { ServiceTemplateService } from '@services';
import { useStore } from '@stores';
import { debounce } from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';

export const useServiceTemplates = () => {
  const { serviceTemplateStore } = useStore();
  const {
    templates,
    totalCount,
    loading,
    saving,
    currentPage,
    skipCount,
    maxResultCount,
    setSkipCount,
    setCurrentPage,
  } = serviceTemplateStore;

  const [keyword, setKeyword] = useState<string>('');

  useEffect(() => {
    serviceTemplateStore.getAll({ keyword, maxResultCount, skipCount });
  }, [keyword, maxResultCount, skipCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const refresh = useCallback(() => {
    serviceTemplateStore.getAll({ keyword, maxResultCount, skipCount });
  }, [keyword, maxResultCount, skipCount]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleKeywordSearch = useMemo(
    () =>
      debounce((text: string) => {
        setKeyword(text);
        setSkipCount(0);
        setCurrentPage(1);
      }, 500),
    [setSkipCount, setCurrentPage]
  );

  const handleDelete = useCallback(
    async (id: number) => {
      await serviceTemplateStore.delete({ id });
      refresh();
    },
    [serviceTemplateStore, refresh]
  );

  const fetchAllForExport = useCallback(async () => {
    const result = await ServiceTemplateService.getAll({
      keyword,
      maxResultCount: totalCount || 10000,
      skipCount: 0,
    });
    return result.items;
  }, [keyword, totalCount]);

  return {
    loading,
    saving,
    dataSource: Array.from(templates.values()),
    totalCount,
    currentPage,
    maxResultCount,
    handlePageChange: serviceTemplateStore.handlePageChange,
    handleKeywordSearch,
    handleDelete,
    refresh,
    fetchAllForExport,
  };
};
